import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { InputHTMLAttributes, ReactElement } from 'react';
import { zIndexVoxel } from '../../../logic/zIndexVoxel';
import VoxelIconButton from '../Buttons/VoxelIconButton';
import VoxelText from '../Text/VoxelText';
import VoxelFormsLabel from './VoxelFormsLabel';

export interface VoxelTextareaProps
  extends Pick<
    InputHTMLAttributes<HTMLTextAreaElement>,
    'onChange' | 'value' | 'placeholder' | 'autoFocus' | 'disabled' | 'maxLength' | 'onBlur'
  > {
  id?: any;
  minRows?: number;
  readOnly?: boolean;
  helperText?: string;
  showHelperText?: boolean;
  helperNotError?: boolean;
  resizeOff?: boolean;
  deleteValue?: () => void;
  label?: string;
  errorText?: string;
  inputCount?: string;
  infoText?: ReactElement;
  showError?: boolean;
}
const VoxelTextarea = React.forwardRef<HTMLTextAreaElement, VoxelTextareaProps>(
  (
    {
      id,
      value,
      onChange,
      placeholder,
      readOnly,
      disabled,
      minRows = 5,
      maxLength,
      helperText,
      showHelperText,
      helperNotError,
      resizeOff,
      deleteValue,
      label,
      errorText,
      inputCount,
      infoText,
      autoFocus,
      showError,
    },
    ref
  ) => {
    return (
      <div className="relative group w-full flex flex-col gap-y-2">
        <VoxelFormsLabel label={label} id={id} disabled={disabled} infoText={infoText} />
        <textarea
          ref={ref}
          value={value}
          onChange={(event) => onChange && onChange(event)}
          placeholder={placeholder}
          rows={minRows}
          maxLength={maxLength}
          disabled={disabled}
          autoFocus={autoFocus}
          className={`
            rounded-md bg-white
            w-full px-4 py-3
            text-sm 
            outline-none
            ${!disabled && 'placeholder-voxel-gray-400'}
            ${!disabled && 'ring-1 ring-voxel-gray-300 '}
            ${!disabled && 'hover:ring-voxel-gray-400'}
            ${!disabled && 'focus:ring-2 focus:ring-primary-600'}
            ${disabled && 'placeholder-voxel-gray-300'}
            ${disabled && 'ring-1 ring-voxel-gray-200 text-gray-500'}
            ${showHelperText && !helperNotError ? 'ring-red-500 ring-2' : ''}
            ${resizeOff ? 'resize-none' : 'resize-y'} 
        `}
        />

        <div
          className={`
        absolute right-2 ${label ? 'top-8' : 'top-2'} 
        ${zIndexVoxel.inputIcon}
        flex flex-row gap-1.5 item-center flex-nowrap
        `}
        >
          {!disabled && deleteValue && !!value && (
            <VoxelIconButton
              type="button"
              onClick={deleteValue}
              color="white"
              size="xs"
              icon={<FontAwesomeIcon icon={faXmark} size="lg" />}
            />
          )}
        </div>

        {!!value && !!inputCount && (
          <div className="absolute z-2 right-5 bottom-1.5">
            <VoxelText align="right" variant="form-caption" color='medium'>
              {inputCount}
            </VoxelText>
          </div>
        )}
        {showHelperText ? (
          <p
            className={`absolute -bottom-6 left-0.5 text-xs ${helperNotError ? 'text-voxel-gray-700' : 'text-red-500'
              }`}
          >
            {helperText}
          </p>
        ) : undefined}
      </div>
    );
  }
);

export default VoxelTextarea;
